import React, { useEffect } from 'react';
import { ConfirmationPrompt } from './ConfirmationPrompt';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  question: string;
  actionType: string;
  onConfirm: () => void;
  theme?: 'light' | 'dark';
}

const Dialog: React.FC<DialogProps> = ({
  isOpen,
  onClose,
  question,
  actionType,
  onConfirm,
  theme = 'light'
}) => {
  useEffect(() => {
    console.log('🎭 Dialog component state changed:', { isOpen, question, actionType });
  }, [isOpen, question, actionType]);

  if (!isOpen) return null;

  const handleConfirm = (e: React.MouseEvent) => {
    console.log('✅ Dialog confirm button clicked');
    e.preventDefault();
    onConfirm();
    onClose();
  };

  const handleDecline = (e: React.MouseEvent) => {
    console.log('❌ Dialog decline button clicked');
    e.preventDefault();
    onClose();
  };

  console.log('🎨 Rendering Dialog component with theme:', theme);
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4 text-center">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black/30 dark:bg-black/50 transition-opacity" 
          onClick={handleDecline}
        />

        {/* Dialog panel */}
        <div className="relative transform overflow-hidden transition-all">
          <ConfirmationPrompt
            question={question}
            actionType={actionType}
            onConfirm={handleConfirm}
            onDecline={handleDecline}
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
};

export default Dialog; 